<template>
    <div :class="addonsInfoImg === true ? 'pt-[20px]' : ''" class="flex flex-col gap-[30px]">
        <div v-if="addonsInfoImg == 0" class="p-[10px] pt-[13px] bg-gradient-to-b from-[#EFEFEF66]/50 to-[#FFFFFF]">
            <h4 class="font-roboto !font-semibold text-left text-[16px] leading-tight text-[#666666]">
                Includes one annual preventative maintenance visit to help keep your systems running efficiently and
                reduce unexpected repairs.</h4>
        </div>
        <h4 v-if="addonsInfoImg" class="text-center !font-bold font-roboto text-[20px] text-[#F5B134]">Repair Coverage</h4>
        <h4 v-else class="text-center !font-bold font-roboto text-[20px] text-[#F5B134]">Maintenance</h4>
        
        <div v-for="(items, trade) in addons" :key="trade"
            class="relative pt-[25px] pb-[15px] px-[20px] rounded-[10px] bg-[#EFEFEF]/40">
            <div class=" flex flex-col gap-[5px]">
                <span
                    class="absolute -top-[10px] left-[15px] w-max inline-block rounded-full px-[10px] py-[0.5px] font-lato text-[12px] text-[#fff] bg-customBlue-100">{{
                        trade }}</span>
                <div v-for="(plan, index) in items" :key="index" class="flex items-center gap-[10px]">
                    <img src="../../../assets/images/check-double-purple.png" alt="Check Icon"
                        class="w-[24px] h-[24px]">
                    <span class="text-[14px] laptop:text-[16px] font-roboto font-normal text-[#333]">{{
                        plan.plan_name }}</span>
                    <img v-if="addonsInfoImg" @click="infoClicked(plan)" src="../../../assets/images/plan-info.svg"
                        alt="Check Icon" class="w-[22px] h-[22px] cursor-pointer">
                </div>
            </div>
        </div>
    </div>


</template>

<script>

import { Modal } from "bootstrap";
import { mapActions, mapGetters } from "vuex";
// import customAccordion from "../../partialComponent/customAccordion.vue";
export default {
    components: {
        // customAccordion
    },

    props: ['addons', 'addonsInfoImg'],

    computed: {
        ...mapGetters([

        ]),
    },

    watch: {


    },
    data() {
        return {

        };
    },

    mounted() {
    },

    methods: {
        ...mapActions([
            "getAddonPlanDetails",
        ]),
        infoClicked(item) {
            this.getAddonPlanDetails({
                id: item.plan_id
            })
        },

        getCoveredData() {
            return [{
                title: "What's covered:",
                content: this.addonPlanDetails?.covered ?? '',
                class: 'planDescription'
            }, {
                title: "What's not covered:",
                content: this.addonPlanDetails?.not_covered ?? '',
                class: 'planDescription'
            }]
        },

    },
};
</script>
<style>
.bundleDescription ul {
    padding: 0;
    text-align: left;
    font-family: 'Roboto' !important;
    gap: 6px;
    display: flex;
    flex-direction: column;
}

.bundleDescription ul li {
    padding-left: 2rem;
    position: relative;
    font-size: 16px !important;
    font-weight: 400 !important;
    font-family: 'Roboto' !important;
    color: #333333 !important;
}

.bundleDescription ul li:after {
    position: absolute;
    content: "";
    top: 2px;
    left: 0;
    background-image: url('../../../assets/images/check-double-purple.png');
    background-position: center;
    background-size: contain;
    width: 22px;
    height: 22px;
}

.excludedItems ul li:after {
    position: absolute;
    content: "";
    top: 2px;
    left: 0;
    background-image: url('../../../assets/images/excluded-items-icon.svg');
    background-position: center;
    background-size: contain;
    width: 22px;
    height: 22px;
}

.bundleDescription p a,
.bundleDescription a {
    color: #2459A8;
}

.bundleDescription ul li span,
.bundleDescription p span {
    font-size: 16px !important;
    font-family: 'Roboto' !important;
}

.bundleDescription p {
    font-size: 16px !important;
    font-family: 'Roboto';
    text-align: left !important;
    margin-bottom: 10px;
    color: #333333;
}

@media screen and (max-width: 767px) {

    .bundleDescription p,
    .bundleDescription ul li,
    .bundleDescription ul li span,
    .bundleDescription p span {
        font-size: 14px !important;
    }

    .bundleDescription ul li:after {
        width: 20px;
        height: 20px;
    }

}
</style>